module.exports = __webpack_public_path__ + "static/media/jwt.cf5ab4f8.png";